import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { useMemo } from "react"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { FieldTemplateOne } from "../../PlantillasBloquesTabla"

const TributacionPorTerritorio = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()

  const casilla84 = useMemo(() => {
    const hasRequiredFields = !!(
      values?.casilla87 ||
      values?.casilla88 ||
      values?.casilla89 ||
      values?.casilla90 ||
      values?.casilla91
    )

    if (!hasRequiredFields) {
      setValue("tribRazTerrCasilla84", undefined)
      return
    }
    const casilla65 = values?.casilla65 ? Number(values?.casilla65) : 0
    const casilla83 = 0
    const casilla658 = values?.tribRazTerrCasilla658
      ? Number(values?.tribRazTerrCasilla658)
      : 0
    const result = casilla65 + casilla83 + casilla658
    setValue("tribRazTerrCasilla84", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla65,
    values?.tribRazTerrCasilla658,
    values?.casilla87,
    values?.casilla88,
    values?.casilla89,
    values?.casilla90,
    values?.casilla91,
  ])

  const casilla92 = useMemo(() => {
    const casilla84 = values?.tribRazTerrCasilla84
      ? Number(values?.tribRazTerrCasilla84)
      : 0
    const casilla87 = values?.casilla87 ? Number(values?.casilla87) : 0
    const result = casilla84 * (casilla87 / 100)
    setValue("casilla92", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.tribRazTerrCasilla84, values?.casilla87])

  const fields: FieldTemplateOne[] = [
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box1"),
      code: "casilla87",
      inputNumber: "87",
      value: values?.casilla87,
      disabled: false,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box2"),
      code: "casilla88",
      inputNumber: "88",
      value: values?.casilla88,
      disabled: false,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box3"),
      code: "casilla89",
      inputNumber: "89",
      value: values?.casilla89,
      disabled: false,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box4"),
      code: "casilla90",
      inputNumber: "90",
      value: values?.casilla90,
      disabled: false,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box5"),
      code: "casilla91",
      inputNumber: "91",
      value: values?.casilla91,
      disabled: false,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box6"),
      code: "tribRazTerrCasilla658",
      inputNumber: "658",
      value: values?.tribRazTerrCasilla658,
      disabled:
        !values?.casilla87 &&
        !values?.casilla88 &&
        !values?.casilla89 &&
        !values?.casilla90 &&
        !values?.casilla91,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box7"),
      code: "tribRazTerrCasilla84",
      inputNumber: "84",
      value: casilla84,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box8"),
      code: "casilla92",
      inputNumber: "92",
      value: casilla92,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box9"),
      code: "tribRazTerrCasilla659",
      inputNumber: "659",
      value: values?.tribRazTerrCasilla659,
      disabled:
        !values?.casilla87 &&
        !values?.casilla88 &&
        !values?.casilla89 &&
        !values?.casilla90 &&
        !values?.casilla91,
    },
    {
      label: t("taxSummary.declaracion.tributacionTerritorio.box10"),
      code: "casilla93",
      inputNumber: "93",
      value: values?.casilla93,
      disabled:
        !values?.casilla87 &&
        !values?.casilla88 &&
        !values?.casilla89 &&
        !values?.casilla90 &&
        !values?.casilla91,
    },
  ]

  const casilla94 = useMemo(() => {
    const casilla92 = values?.casilla92 ? Number(values?.casilla92) : 0
    const casilla659 = values?.tribRazTerrCasilla659
      ? Number(values?.tribRazTerrCasilla659)
      : 0
    const casilla93 = values?.casilla93 ? Number(values?.casilla93) : 0
    const result = casilla92 + casilla659 - casilla93
    setValue("casilla94", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.casilla92, values?.tribRazTerrCasilla659, values?.casilla93])

  return (
    <div className='tw-w-full tw-px-6 tw-pb-6'>
      <div className='tw-flex tw-flex-col'>
        {fields.map((field, index) => (
          <div
            key={field.code}
            className='tw-grid tw-grid-cols-5 tw-items-center tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3'
          >
            <div className='tw-col-span-4 tw-text-sm'>{field.label}</div>
            <div className='tw-col-span-1'>
              <InputCurrencyGroup
                suffix={index > 4 ? "€" : "%"}
                value={typeof field.value === "number" ? field.value : 0}
                onChange={(value) => {
                  setValue(`${field.code}`, value ?? 0)
                }}
                placeholder='0,00'
                className='tw-w-full tw-h-full tw-text-sm'
                numberGroup={String(field.inputNumber)}
                disabled={field.disabled}
              />
            </div>
          </div>
        ))}

        <div className='tw-grid tw-grid-cols-5 tw-items-center tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3'>
          <div className='tw-col-span-4 tw-font-bold tw-text-sm'>
            {t("taxSummary.declaracion.tributacionTerritorio.box11")}
          </div>
          <div className='tw-col-span-1'>
            <InputCurrencyGroup
              suffix='€'
              placeholder='0,00'
              className='tw-w-full tw-h-full tw-text-sm'
              numberGroup='94'
              value={casilla94}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TributacionPorTerritorio
